import { render, staticRenderFns } from "./LoanPromoPopup.vue?vue&type=template&id=05b5e029&scoped=true"
import script from "./LoanPromoPopup.vue?vue&type=script&lang=js"
export * from "./LoanPromoPopup.vue?vue&type=script&lang=js"
import style0 from "./LoanPromoPopup.vue?vue&type=style&index=0&id=05b5e029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5e029",
  null
  
)

export default component.exports